<button type="button" mat-stroked-button class="button_large_clear full_width relative" [attr.aria-label]="ariaLabel"
    (click)="eeClick.emit()"
	[disabled]="bWorking"
>
    <img matPrefix src="/assets/img/icons/google.svg"/>
    Google
	<mat-spinner matSuffix class="black" *ngIf="bWorking" diameter="21" strokeWidth="2"></mat-spinner>
</button>